import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconNotificationWarning({
    color = '#B82D1D',
    className,
    ariaHidden = false,
    size = 20,
}: IconProps): ReactElement {
    return (
        <svg
            width={size}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            className={className}
            aria-hidden={ariaHidden}
        >
            <circle cx={12} cy={12} r={9} fill={color} stroke={color} strokeWidth={2} />
            <rect
                x={13.406}
                y={13.477}
                width={2.813}
                height={8.174}
                rx={1.406}
                transform='rotate(-180 13.406 13.477)'
                fill='#fff'
            />
            <rect
                x={13.406}
                y={17.696}
                width={2.813}
                height={2.813}
                rx={1.406}
                transform='rotate(-180 13.406 17.696)'
                fill='#fff'
            />
        </svg>
    );
}
